import { useGoBack } from 'hooks/useGoBack';
import React, { useContext, useCallback } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IEditVideoContext, EditVideoContext } from '../../editVideoState/editVideoContext';
import { convertUndefinedFields } from 'utils/helpers';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import CreateStudioState from './CreateStudioModal/createStudioModalContext/createStudioModalState/CreateStudioModalState';
import CreateStudioModal from './CreateStudioModal/CreateStudioModal';
import { editVideo } from 'backend/videos';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { refetchData, changeTypeOfModalWindow, dataForSubmit, typeOfModalWindow } =
		useContext<IEditVideoContext>(EditVideoContext);
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/entertainment/videos');
	}, [goBack]);

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await editVideo(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleUpdateData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleUpdateData}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'fileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: '150MB' }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'invalidFileFormat'}
				description="invalidFileFormatPhoto"
				translationOptions={{ formats: '.jpeg, .jpg, .png' }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'fileUploadError'}
				description="fileUploadError"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'someTranslationIsEmpty'}
				description="errorDefaultTranslation"
			/>
			<CreateStudioState>
				<CreateStudioModal isVisible={typeOfModalWindow === 'createStudio'} />
			</CreateStudioState>
		</ModalWrapper>
	);
};
